import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSampleViewHeader from '@/modules/grossingModule/grossing-touch-view/views/grossing-touch-sample-view/grossing-touch-sample-view-header/grossing-touch-sample-view-header.vue'
import GrossingTouchTagsSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-tags-sidepanel/grossing-touch-tags-sidepanel.vue'

@Component({
    components: {
        GrossingTouchSampleViewHeader,
        GrossingTouchTagsSidepanel
    }
})

export default class GrossingTouchSampleTabData extends Vue {
}
